"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGuestListNavItems = exports.getGuestListSecondaryNavItems = void 0;

var _navConstants = require("../constants/navConstants");

/**
 * Used in web-preauth, web-wedding
 */
var parent = _navConstants.PrimaryNavIdentifier.GUEST_LIST;
var businessUnit = 'GUESTLIST';

var getGuestListSecondaryNavItems = function getGuestListSecondaryNavItems() {
  var events = {
    path: '/wedding/manage/events',
    title: 'Events',
    id: _navConstants.SecondaryNavIdentifier.EVENTS,
    parent: parent,
    businessUnit: businessUnit
  };
  var superLink = {
    path: '/wedding/manage/guests/collection-link',
    title: 'Contact Collector',
    id: _navConstants.SecondaryNavIdentifier.SUPER_LINK,
    parent: parent,
    businessUnit: businessUnit
  };
  var hotelBlocks = {
    title: 'Hotel blocks',
    path: 'https://zola.hotelplanner.com/Group-Rate/?kw=guestnav',
    parent: parent,
    businessUnit: businessUnit
  };
  var guestList = {
    path: '/wedding/manage/guests/all',
    title: 'Guest list',
    id: _navConstants.SecondaryNavIdentifier.ALL_GUESTS,
    parent: parent,
    businessUnit: businessUnit
  };
  return [guestList, superLink, events, hotelBlocks];
};

exports.getGuestListSecondaryNavItems = getGuestListSecondaryNavItems;

var getGuestListNavItems = function getGuestListNavItems(hideNav) {
  if (hideNav) {
    return [];
  }

  var manage = {
    path: '/wedding/manage/guests/all',
    title: 'Manage guest list',
    id: _navConstants.TertiaryNavIdentifier.MANAGE_GUEST_LIST,
    parent: parent,
    businessUnit: businessUnit
  };
  var invite = {
    path: '/wedding/manage/guests/build',
    title: 'Invite guests to events',
    id: _navConstants.TertiaryNavIdentifier.INVITE_GUESTS,
    parent: parent,
    businessUnit: businessUnit
  };
  var address = {
    path: '/wedding/manage/guests/envelopes',
    title: 'Address envelopes',
    id: _navConstants.TertiaryNavIdentifier.ADDRESS_ENVELOPES,
    parent: parent,
    businessUnit: businessUnit
  };
  var track = {
    path: '/wedding/manage/guests/rsvps/overview',
    title: 'Track RSVPs',
    id: _navConstants.TertiaryNavIdentifier.TRACK_RSVPS,
    parent: parent,
    businessUnit: businessUnit
  };
  return [manage, invite, address, track];
};

exports.getGuestListNavItems = getGuestListNavItems;